import React, { useState } from "react";
import { AiOutlineArrowLeft, AiOutlineClose } from "react-icons/ai";
import { BroadcastScreen } from "../BroadcastScreen/BroadcastScreen";

const CreateBroadcast = ({ guests, onClose }) => {
  const [selectedGuests, setSelectedGuests] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isBroadcastModalOpen, setBroadcastModalOpen] = useState(false);

  const handleGuestSelection = (guestId) => {
    setSelectedGuests((prev) =>
      prev.includes(guestId)
        ? prev.filter((id) => id !== guestId)
        : [...prev, guestId]
    );
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedGuests([]);
    } else {
      const allGuestIds = Object.values(guests.chatLists).map(
        (chat) => chat.guest._id
      );
      setSelectedGuests(allGuestIds);
    }
    setSelectAll(!selectAll);
  };

  const handleSubmit = () => {
    setBroadcastModalOpen(true);
    // onClose(); // Close the CreateBroadcast modal
  };

  const closeBroadcastModal = () => {
    setBroadcastModalOpen(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end justify-end z-50">
      <div className="bg-white p-0 rounded-xl rounded-t-2xl shadow-lg max-w-md w-[30vw] min-w-[350px] m-4 h-[80vh] relative">
        <div className="bg-indigo-600 p-4 rounded-t-xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <button
                onClick={onClose}
                className="text-indigo-700 border bg-white h-10 w-10 flex items-center justify-center rounded-xl focus:outline-none"
              >
                <AiOutlineArrowLeft className="h-5 w-5" />
              </button>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:text-gray-200 focus:outline-none"
            >
              <AiOutlineClose className="h-5 w-5 " />
            </button>
          </div>
        </div>

        <div className="overflow-y-auto h-[60vh]">
          {guests?.chatLists ? (
            <div>
              <div className="flex items-center justify-between text-sm px-4 py-1 text-gray-500 bg-gray-100">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                  />
                  <label className="ml-2 text-md font-medium text-gray-900">
                    Select All
                  </label>
                </div>
                <div className="text-md font-medium text-gray-900">
                  {selectedGuests.length} Guests
                </div>
              </div>
              <hr className="border-gray-200" />
              <ul className="divide-y divide-gray-200">
                {Object.values(guests.chatLists).map((chat) => (
                  <li
                    key={chat._id}
                    className={`flex items-center justify-between p-2 px-4 space-x-4 hover:bg-gray-50 cursor-pointer`}
                  >
                    <input
                      type="checkbox"
                      checked={selectedGuests.includes(chat.guest._id)}
                      onChange={() => handleGuestSelection(chat.guest._id)}
                      className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                    />
                    <div className="flex-shrink-0 ml-2">
                      <div className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-indigo-500 text-white">
                        {`${chat.guest.firstName[0]}${chat.guest.lastName[0]}`}
                      </div>
                    </div>
                    <div className="ml-4 flex-1">
                      <div className="text-sm font-medium text-gray-900">
                        {`${chat.guest.firstName} ${chat.guest.lastName}`}
                      </div>
                      <p className="text-sm text-gray-500">
                        {chat.guest.countryCode}
                        {chat.guest.phoneNumber}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <p>Loading guests...</p>
          )}
        </div>

        <hr className="border-gray-200" />

        <div className="bg-gray-100 p-2 px-4 rounded-b-xl">
          <button
            onClick={handleSubmit}
            className="w-full bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
          >
            Proceed
          </button>
        </div>
      </div>

      {/* BroadcastScreen Modal */}
      {isBroadcastModalOpen && (
        <BroadcastScreen
          guestIds={selectedGuests}
          onClose={closeBroadcastModal}
          createClose={onClose}
        />
      )}
    </div>
  );
};

export default CreateBroadcast;
